import React from 'react'
import Banner from '../../components/Banner/Banner'
import RowList from '../../components/Rows/RowList/RowList'

function Home() {
  return (
    <>
        <Banner />
        <RowList />
    </>
  )
}

export default Home